module.exports = __webpack_public_path__ + "media/fonts/Oricons-46fcdc7cb0fca2e10f1ba1f0f9041477.ttf";